import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { QrCode, FileText, BookOpen } from "lucide-react";
import api from "../lib/api";
import { Spinner, Pill } from "./Primitives";

export default function AdminScans() {
  const [scans, setScans] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/qr-scans").then((r) => setScans(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <Spinner />;
  if (scans.length === 0) {
    return (
      <p className="mt-10 border border-dashed border-edge p-12 text-center text-muted" data-testid="scans-empty">
        No QR scans yet. Counts appear here once students scan the QR code on a printed worksheet.
      </p>
    );
  }

  const total = scans.reduce((s, x) => s + (x.count || 0), 0);

  return (
    <div className="mt-10" data-testid="admin-scans">
      <div className="mb-4 flex items-center gap-3">
        <QrCode className="h-5 w-5 text-gold" />
        <p className="text-bone">{total} total {total === 1 ? "scan" : "scans"} across {scans.length} printed {scans.length === 1 ? "worksheet" : "worksheets"}</p>
      </div>
      <div className="overflow-x-auto border border-edge">
        <table className="w-full text-left text-sm">
          <thead>
            <tr className="border-b border-edge bg-ash font-mono text-[11px] uppercase tracking-[0.12em] text-muted">
              <th className="px-4 py-3">Worksheet</th>
              <th className="px-4 py-3">Type</th>
              <th className="px-4 py-3 text-right">Scans</th>
              <th className="px-4 py-3">Last scanned</th>
            </tr>
          </thead>
          <tbody>
            {scans.map((s) => (
              <tr key={`${s.kind}-${s.slug}`} className="border-b border-edge/50 last:border-0" data-testid={`scan-row-${s.kind}-${s.slug}`}>
                <td className="px-4 py-3">
                  <Link to={s.kind === "assignment" ? `/assignments/${s.slug}` : `/lessons/${s.slug}/worksheet`}
                    className="text-bone hover:text-gold">{s.title}</Link>
                </td>
                <td className="px-4 py-3">
                  {s.kind === "assignment"
                    ? <Pill tone="gold"><FileText className="mr-1 inline h-3 w-3" /> Assignment</Pill>
                    : <Pill tone="muted"><BookOpen className="mr-1 inline h-3 w-3" /> Lesson</Pill>}
                </td>
                <td className="px-4 py-3 text-right font-mono text-gold">{s.count}</td>
                <td className="px-4 py-3 text-muted">{s.last_scanned_at ? new Date(s.last_scanned_at).toLocaleString() : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
